module.exports = __webpack_public_path__ + "img/1518754053.840660c5.jpg";